//this is here until they fix the exported types
//https://github.com/react-component/slider/issues/835
//https://github.com/react-component/slider/issues/891
import { ForwardedRef, forwardRef, useMemo } from 'react';
import React from 'react';

import { uniqueId, debounce } from 'lodash';
import RcSlider, { SliderProps, SliderRef } from 'rc-slider/lib/Slider';
import { ITooltip } from 'react-tooltip';
import { getTooltipRender } from 'ui-kit/index';

type TipFormatter = (value: number) => React.ReactNode;
export const RangeSlider = forwardRef(
  (
    props: SliderProps<number[]> & {
      withTooltip?: boolean;
      alwaysShowTooltip?: boolean;
      tooltip?: {
        tipFormatter?: TipFormatter;
        tipProps?: ITooltip;
      };
      minMaxFormatter?: (value: number | undefined) => string;
    },
    ref: ForwardedRef<SliderRef>,
  ) => {
    const { withTooltip, tooltip, alwaysShowTooltip = false, ...sliderProps } = props;

    const sliderUniqueId = useMemo(() => uniqueId('slider-'), []);

    const tipRender = useMemo(
      () =>
        withTooltip
          ? getTooltipRender(
              sliderUniqueId,
              tooltip?.tipFormatter,
              tooltip?.tipProps,
              alwaysShowTooltip,
            )
          : undefined,
      [withTooltip, tooltip?.tipFormatter, tooltip?.tipProps, sliderUniqueId, alwaysShowTooltip],
    );

    const debouncedOnChange = useMemo(
      () => (props.onChange ? debounce(props.onChange, 100) : undefined),
      [props.onChange],
    );

    const railStyle = { backgroundColor: '#323232' };
    const trackStyle = { backgroundColor: '#ea27c2' };
    const handleStyle = {
      borderColor: '#ea27c2',
      backgroundColor: '#ea27c2',
      borderWidth: '#ea27c2',
    };

    // When range=true, trackStyle and handleStyle can be arrays (for multiple segments/handles)
    const trackStyles = Array.isArray(sliderProps.value) ? [trackStyle] : trackStyle;
    const handleStyles = Array.isArray(sliderProps.value)
      ? [handleStyle, handleStyle]
      : handleStyle;

    return (
      <div className="flex items-center gap-4 text-white" id={sliderUniqueId}>
        {props.minMaxFormatter ? props.minMaxFormatter(props.min) : props.min}
        <RcSlider
          {...(sliderProps as SliderProps<number[] | number>)}
          ref={ref}
          range={true}
          handleRender={tipRender}
          allowCross={false}
          railStyle={railStyle}
          trackStyle={trackStyles as any}
          handleStyle={handleStyles as any}
          onChange={debouncedOnChange as SliderProps<number[] | number>['onChange']}
        />
        {props.minMaxFormatter ? props.minMaxFormatter(props.max) : props.max}
      </div>
    );
  },
);
